import React from "react";
import { useOutlet, Navigate, useLocation } from "react-router-dom";
import { GetLocalStorageData } from "../Helpers/Utilities";

export const PublicRoute = () => {
  const outlet = useOutlet();
  const location = useLocation();

  const GetRouteElement = () => {
    if (location.pathname === "/" && GetLocalStorageData("eUser")) {
      return <Navigate to="/Home" />;
    }

    return outlet;
  };

  return GetRouteElement();
};
